import { Component, OnInit } from '@angular/core';
import { CsrgsService } from "src/app/shared/csrgs.service";

@Component({
  selector: 'app-open-admission',
  templateUrl: './open-admission.component.html',
  styleUrls: ['./open-admission.component.css']
})
export class OpenAdmissionComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  nextYear: number = this.currentYear + 1;

  myInterval = 5000;
  activeSlideIndex = 0;

  slides: { photoURL: string }[] = [];
  albumId = 15; // to do dynamic

  constructor(private service: CsrgsService) { }

  ngOnInit(): void {
    this.service.getAllBannerImages(this.albumId).subscribe({
      next: (data: any[]) => {
        this.slides = data;
        console.log('Fetched slides:', this.slides);
      },
      error: (err) => {
        console.error('Failed to load banner images:', err);
      }
    });
  }
}
